import {
  NetworkStatus,
  useNetworkStatus,
} from "$global-providers/network-status-provider/provider";
import { useLazyUser } from "$global-providers/user-provider";
import { linkToOfflineTokenExpired } from "$routes/offline/links";
import { linkToLogin } from "$routes/user/links";
import { useAuth0 } from "@auth0/auth0-react";
import type { Role } from "elephant-web/gql";
import { Navigate, Outlet } from "react-router-dom";
import { linkToUnauthorized } from "./links";

export const RequireAuth: FCwC<{ only?: Role[]; except?: Role[] }> = ({
  children = <Outlet />,
  only,
  except,
}) => {
  const { isLoading, isAuthenticated } = useAuth0();
  const user = useLazyUser();
  const networkStatus = useNetworkStatus();

  if (!isLoading) {
    if (!isAuthenticated || !user) {
      if (networkStatus.networkStatus === NetworkStatus.OFFLINE) {
        return <Navigate to={linkToOfflineTokenExpired()} />;
      }
      return <Navigate to={linkToLogin()} />;
    }
    const { role } = user;

    if (only && except) {
      throw new Error("Please specify only either only or except.");
    }

    let isAuthorised = true;

    if (only) {
      isAuthorised = role !== undefined && only.includes(role);
    }

    if (except) {
      isAuthorised = role !== undefined && !except.includes(role);
    }

    if (!isAuthorised) {
      return <Navigate to={linkToUnauthorized()} />;
    }

    return <>{children}</>;
  }
};
